module.exports = __webpack_public_path__ + "media/customizations/landings/back-c054314048832fca6d1a37fbbed0c109.jpg";